import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const RecentSearchesSectionSkeleton = () => {
  return (
    <div className={s.containerSkeleton}>
      <Skeleton
        circle
        width={40}
        height={40}
      />

      <div className={s.left}>
        <Skeleton
          width={120}
          height={18}
        />

        <Skeleton
          width={180}
          height={16}
        />
      </div>
    </div>
  )
}
